import {Component, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";

@Component({
    selector: 'app-ashtmhome',
    templateUrl: './ashtmhome.component.html',
    styleUrls: ['./ashtmhome.component.scss']
})
export class AshtmhomeComponent implements OnInit {

    constructor(private meta: Meta,
                private titles: Title) {
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);

        this.updateMetaTags();
    }

    updateMetaTags() {
        this.titles.setTitle('Hospitality Management Courses at ARNI School of Hotel Management & Tourism');
        this.meta.updateTag({
            name: 'description',
            content: `Explore hospitality management courses at ARNI School of Hotel Management & Tourism. Build a career in the dynamic hospitality industry with our expert-led programs.`
        });
    }

}
